module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('server-option', {
    attrs: {
      "option": _vm.option
    }
  }), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveServer()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-48b788b6"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/server/Setting.vue
// module id = 162
// module chunks = 1